import { generateBinaryQuestionPrompt } from '../components/prompts/binaryQuestionPrompt';
import { generateMultipleChoicePrompt } from '../components/prompts/multipleChoicePrompt';
import { generateScalePrompt } from '../components/prompts/scalePrompt';
import { generateStackRankPrompt } from '../components/prompts/stackRankPrompt';
import { generateOpenEndedPrompt } from '../components/prompts/openEndedPrompt';
import { generateMultipleRatingPrompt } from '../components/prompts/multipleRatingPrompt';

export const getQuestionSpecificPrompt = (questionType, promptData) => {
  // console.log('🔎 getQuestionSpecificPrompt called with:', {
  //   questionType,
  //   hasPromptData: !!promptData,
  //   promptDataKeys: promptData ? Object.keys(promptData) : [],
  //   hasEventDetails: !!promptData?.eventDetails,
  //   hasStats: !!promptData?.stats,
  //   hasPosts: !!promptData?.posts,
  //   timestamp: new Date().toISOString()
  // });

  if (!questionType) {
    console.error('❌ Missing questionType in getQuestionSpecificPrompt');
    return null;
  }

  if (!promptData || !promptData.eventDetails || !promptData.stats) {
    console.error('❌ Missing or incomplete promptData in getQuestionSpecificPrompt', { promptData });
    return null;
  }

  try {
    let prompt = null;
    const { eventDetails, posts, stats } = promptData;

    const normalizedType = questionType.toUpperCase();

    switch(normalizedType) {
      case 'BINARY':
      case 'YES/NO':
      case 'YES_NO':
        // console.log('📝 Generating binary question prompt with details, stats, and posts');
        prompt = generateBinaryQuestionPrompt(eventDetails, stats, posts);
        break;
      case 'MULTIPLE_CHOICE':
      case 'MULTIPLE':
      case 'MULTI':
        // console.log('📝 Generating multiple choice prompt');
        prompt = generateMultipleChoicePrompt(eventDetails, stats);
        break;
      case 'MULTIPLE_RATING':
        // console.log('📝 Generating multiple rating prompt');
        prompt = generateMultipleRatingPrompt(eventDetails, stats);
        break;
      case 'SCALE':
      case 'SCALE_5':
      case 'SCALE_10':
        // console.log('📝 Generating scale prompt');
        prompt = generateScalePrompt(eventDetails, stats);
        break;
      case 'STACK_RANK':
        // console.log('📝 Generating stack rank prompt with posts');
        prompt = generateStackRankPrompt(eventDetails, stats, posts);
        break;
      case 'OPEN_ENDED':
      case 'DEFAULT':
        // console.log('📝 Generating open ended prompt');
        prompt = generateOpenEndedPrompt(eventDetails, posts, stats);
        break;
      default:
        console.warn(`⚠️ Unknown question type: ${questionType} (normalized: ${normalizedType})`);
        console.log('📝 Falling back to open ended prompt');
        prompt = generateOpenEndedPrompt(eventDetails, posts, stats);
    }

    // console.log('📝 Prompt generation result:', {
    //   questionType,
    //   normalizedType,
    //   hasPrompt: !!prompt,
    //   promptLength: prompt?.length,
    //   timestamp: new Date().toISOString()
    // });

    return prompt;
  } catch (error) {
    console.error('❌ Error in getQuestionSpecificPrompt:', {
      error: error.message,
      stack: error.stack,
      questionType,
      timestamp: new Date().toISOString()
    });
    return null;
  }
}; 